import { render, staticRenderFns } from "./BranchSettings.vue?vue&type=template&id=43d98d40&"
import script from "./BranchSettings.vue?vue&type=script&lang=js&"
export * from "./BranchSettings.vue?vue&type=script&lang=js&"
import style0 from "./BranchSettings.vue?vue&type=style&index=0&id=43d98d40&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports